module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-help-aib",
      "title": "Help"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f334584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Help.vue
// module id = 884
// module chunks = 39